"use client";

import { POLARIS_CONFIG } from "@/constants/polaris";
import React, { memo } from "react";

type PolarisElementType = "header" | "footer";

interface PolarisElementProps {
  element: PolarisElementType;
  className?: string;
  style?: React.CSSProperties;
  autoAuth?: "true" | "false";
}

const defaultStyles: Record<PolarisElementType, React.CSSProperties> = {
  header: {},
  footer: {},
};

const PolarisElement = memo<PolarisElementProps>(
  ({ element, className, style, autoAuth }) => {
    const elementName = `xc-${element}`;
    const mergedStyles = { ...defaultStyles[element], ...style };

    return React.createElement(elementName, {
      "client-id": POLARIS_CONFIG.clientId,
      "hide-back": true,
      "legal-corporate": true,
      theme: "light",
      simpleheader: true,
      flownav: true,
      className,
      style: mergedStyles,
      ...(autoAuth && { "auto-auth": autoAuth }),
    });
  }
);

PolarisElement.displayName = "PolarisElement";

export const PolarisHeader = memo(
  (props: Omit<PolarisElementProps, "element">) => (
    <PolarisElement element="header" {...props} autoAuth="true" />
  )
);
PolarisHeader.displayName = "Header";

export const PolarisFooter = memo(
  (props: Omit<PolarisElementProps, "element">) => (
    <PolarisElement element="footer" {...props} />
  )
);
PolarisFooter.displayName = "Footer";

export default PolarisElement;
